import { render, staticRenderFns } from "./WayToPay.vue?vue&type=template&id=6e716bae&scoped=true&"
import script from "./WayToPay.vue?vue&type=script&lang=js&"
export * from "./WayToPay.vue?vue&type=script&lang=js&"
import style0 from "./WayToPay.vue?vue&type=style&index=0&id=6e716bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e716bae",
  null
  
)

export default component.exports